import DataStorageService from '../DataStorageService';


export default new DataStorageService(window.sessionStorage);
